import { Input, Label } from 'reactstrap';
import { handleSortBy } from './CatCheckBoxUtils';
import { useSelector, useDispatch } from 'react-redux';

const defaultSortOptions = [
  { value: '-id', label: 'Terbaru' },
  { value: 'id', label: 'Terlama' },
  { value: 'name', label: 'A-Z' },
  { value: '-name', label: 'Z-A' },
];

const PriceCheck = ({
  filters: externalFilters,
  onSortChange,
  title = 'Sort by:',
  name = 'sort',
  sortField = 'sort',
  options = defaultSortOptions,
  idPrefix = 'sort-option',
}) => {
  const dispatch = useDispatch();
  const subMaterialFilters = useSelector(state => state.subMaterial.filters);

  // Jika dipanggil tanpa props, fallback ke behavior lama (submateri).
  const filters = externalFilters || subMaterialFilters;

  // Jika parent kirim handler, gunakan itu. Kalau tidak, pakai handler lama.
  const handleChange = onSortChange || handleSortBy(filters, dispatch);

  return (
    <div className="checkbox-animated mt-0">
      <div className="learning-header"><span className="f-w-600">{title}</span></div>
      {options.map((option, index) => {
        const optionId = `${idPrefix}-${index}`;

        return (
          <Label className="d-block" htmlFor={optionId} key={option.value}>
            <Input
              className="radio_animated"
              id={optionId}
              type="radio"
              name={name}
              checked={filters?.[sortField] === option.value}
              value={option.value}
              onChange={handleChange}
            />
            {option.label}
          </Label>
        );
      })}
    </div>
  );
};

export default PriceCheck;